module.exports = __webpack_public_path__ + "static/media/clearSearch.feb9c5e8.svg";